import { Vendor } from '@interfaces/vendor';
import { getCall } from '@services/rest-service';

// Retrieves all the vendors from cosmos
export const getVendors = (): Promise<Vendor[]> => {
  return getCall<Vendor[]>('vendors');
};